export default __webpack_public_path__ + "static/media/the_protector_1.66bd83ab.png";